import * as React from "react"

import * as styles from "./imageheader.module.css"

const ImageHeader = () => (
		<div className={styles.imageHeaderContainer}>
			<img src="/images/about_map_2200x350.png" className="img-fluid" alt=""/>
		</div>
)

export default ImageHeader
